import { makeStyles } from '@material-ui/styles'

export default makeStyles((theme) => ({
  tabPanelContainer: {
    flex: 1,
    backgroundColor: theme.palette.web.white
  }
}))
